import React from 'react';
import { FaRegLightbulb, FaUndo } from 'react-icons/fa';
import { showHintPositions } from '../helpers/cameraPositions';
import { logHintUsed, logEvent } from '../../utils/experimentLog';

// 「ヒント」ボタン：3Dモデルを「おかしさが分かる視点」へ動かす（研究用語では「顕在化された視点」）。
// 部品選択（X-1）と形状変更シミュレーション（X-2）で共用する。
// トグル式（2026-10-12）：ヒントの視点にいる間（shown）は【もとの視点に戻す】になり、
// 押すともとの視点（既定視点＝デッサンを描いた斜め上からの視点）へ戻す（デッサンと見比べられるようにする。2026-10-19に「押す直前の視点」から変更）。
// 視点の動かし方は画面ごとに違うので、onShow(position)／onReset() で呼び出し側へ任せる。
// disabled：視点が動いている間（行き・帰りとも）は押させない。
// 押した時刻はステップを開いてからの経過時間つきで記録する（logHintUsed）。戻したときは hint_reset。
export default function ShowHintButton({ glbPath, onShow, onReset, shown = false, disabled = false }) {
  const position = showHintPositions[glbPath];
  if (!position) return null; // 対応しないモデルはボタンを表示しない

  const handleClick = () => {
    if (disabled) return;
    if (shown) {
      if (typeof onReset === 'function') {
        logEvent('hint_reset', { glbPath });
        onReset();
      }
      return;
    }
    if (typeof onShow !== 'function') {
      console.warn('ShowHintButton: onShow is not a function');
      return;
    }
    logHintUsed({ glbPath });
    onShow(position);
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={disabled}
      className="btn-hint"
      title={shown ? 'もとの視点に戻す' : 'おかしさが分かる視点で見る'}
    >
      {shown ? (
        <>
          <FaUndo className="btn-hint__icon" aria-hidden="true" />
          <span className="btn-hint__text">もとの視点に戻す</span>
        </>
      ) : (
        <>
          <FaRegLightbulb className="btn-hint__icon" aria-hidden="true" />
          <span className="btn-hint__label">ヒント</span>
          <span className="btn-hint__text">おかしさが分かる視点で見る</span>
        </>
      )}
    </button>
  );
}
